<script>
export default {
  name: 'RfOption',
  render: function (createElement) {
    // Optgroups
    if (typeof this.option.value === 'object') {
      // Build array of options for the group
      let groupOptions = this.option.value.map(function (option) {
        return createElement('option', {
          domProps: {
            // The order of the short circuit is important: use explicit value first, then label if value not present, etc.
            value: option.value || option.label || option
          }
        }, option.label || option.value || option) // The order matters, see above
      })
      // Render the optgroup and its children (the options)
      return createElement('optgroup', {
        domProps: {
          label: this.option.label
        }
      }, groupOptions)

    // Options
    } else {
      return createElement('option', {
        domProps: {
          value: this.option.value || this.option.label || this.option  // The order matters, see above
        }
      }, this.option.label || this.option.value || this.option)  // The order matters, see above
    }
  },
  props: {
    option: {
      type: [String, Object],
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// RfOption.vue?7da2ddec